/* eslint-disable implicit-arrow-linebreak */

export const getIsPlatformMac = () => navigator.platform.toUpperCase().indexOf('MAC') >= 0;
